const getters = {
  getRoute: state => state.app.route,
  user: state => state.app.user,
  tipoCliente: state => state.app.tipoCliente,
  empresa: state => state.app.empresa,
  empresas: state => state.app.empresas,
  suscripcion: state => state.app.suscripcion,
  drawer: state => state.app.drawer,
  language: state => state.app.language,
  busy: state => state.app.busy,
  busyText: state => state.app.busyText,
  misCpcs: state => state.app.misCpcs,
  scrollPosition: state => state.app.scrollPosition,

  //DASHBOARD
  dashboardDrawer: state => state.dashboard.dashboardDrawer,
  addOrEditFilterDialogVisible: state =>
    state.dashboard.addOrEditFilterDialogVisible,
  seletFilterDialogVisible: state => state.dashboard.seletFilterDialogVisible,
  saveQueryDialogVisible: state => state.dashboard.saveQueryDialogVisible,
  filters: state => state.dashboard.filters,
  filterList: (state, getters) => {
    return Array.from(
      new Set(getters.filters.map(filtro => filtro.field.value))
    );
  },
  filterExcluded: (state, getters) => {
    return Array.from(
      new Set(
        getters.filters
          .filter(item => {
            if (item.field.hasOwnProperty("excludeInView")) {
              return item.field.excludeInView.includes(getters.getRoute);
            }
          })
          .map(filtro => filtro.field.label)
      )
    );
  },
  queries: state => state.dashboard.queries,
  snapshots: state => state.dashboard.snapshots,
  errorLogs: state => state.errorLog.logs

  //TIPS
  //tipsMisCpcs: state => state.tips.tipsMisCpcs,
  //tipsComponentes: state => state.tips.Componentes,
};

export default getters;
